

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { Artist, ArtistSearchRequest, PagedResult } from '@shared/models';
	import ArtistItem from '@client/views/industry/artists/ArtistItem.vue';

	@Component({
		components: {
			ArtistItem,
		},
	})
	export default class CompanyDecks extends BaseView {

		public modelId: string = '';
		public list: PagedResult<Artist> = new PagedResult<Artist>();
		public criteria: ArtistSearchRequest = new ArtistSearchRequest({ pageIndex: 0, pageSize: 32, sortBy: 'displayname', sortDirection: 'asc' });

		public async mounted() {
			await this.refresh();
		}

		public async refresh() {
			this.loading = true;
			try {
				this.modelId = this.$route.params.id;
				this.criteria.companyIds.push(this.modelId);
				this.list = await this.$api.artistService.search(this.criteria);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this companies artist list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			this.refresh();
		}


	}

